import { stripHtml } from '~/utils/strip-html';

import { FaqMapperParams } from '../structuredMappers/faq';

export const rawToFaq = (data: {
  item: [
    {
      list: {
        accordionTitle: string;
        content: [{ content: string }];
      }[];
    }
  ];
}): FaqMapperParams => ({
  items:
    data.item[0].list
      .filter((item) => item.accordionTitle.endsWith('?'))
      .map((item) => ({
        title: item.accordionTitle,
        content: stripHtml(item.content[0].content),
      })) || [],
});
